import { styled } from "@mui/material";
import Button from "@mui/material/Button";

export const SettingsButton = styled(Button)({
  padding: "12px 18px",
  background: "#E6E4FF",
  "& span": {
    textTransform: "none",
    color: "#5A52C3",
    fontWeight: 700,
  },
  "&:disabled": {
    background: "#efefef",
  },
  "&:disabled span": {
    color: "#00000042",
  },
});
